import { Coach } from "@/models";
import restApiDispatcher from "@/store/utils/api-dispatcher";

const createCoach = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "create",
    storeKey: "coach",
    commitType: "show",
    loadingKey: "coachLoading",
    message: "Coach Created",
    params
  });

const createClubCoach = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "createClubCoach",
    storeKey: "coach",
    commitType: "show",
    loadingKey: "coachLoading",
    params
  });

const getCoaches = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "index",
    storeKey: "coaches",
    commitType: "index",
    metaKey: "meta",
    loadingKey: "coachesLoading",
    params
  });

const getCoach = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "showWithProfileId",
    storeKey: "coach",
    commitType: "show",
    loadingKey: "coachLoading",
    params
  });

const getSingleCoach = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "getClubCoach",
    storeKey: "singleCoach",
    commitType: "show",
    loadingKey: "singleCoachLoading",
    silent: true,
    params
  });

const getSingleCollegeCoach = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "getCollegeCoach",
    storeKey: "singleCoach",
    commitType: "show",
    loadingKey: "singleCoachLoading",
    silent: true,
    params
  });

const updateCoach = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "update",
    storeKey: "coach",
    commitType: "wrappedShow2",
    loadingKey: "coachLoading",
    message: "Coach sucessfully Updated",
    params
  });

const toggleActivation = (context, params) => {
  restApiDispatcher(context, {
    resource: Coach,
    action: "toggleActivation",
    storeKey: "coach",
    commitType: "update",
    loadingKey: "coachesLoading",
    message: _.capitalize(`Profile ${params.flag}d`),
    params
  });
};

const updateRole = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "updateRole",
    storeKey: "coach",
    commitType: "update",
    loadingKey: "coachesLoading",
    message: "coach role updated",
    params
  });

const deleteCoach = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "deleteCoach",
    storeKey: "coach",
    loadingKey: "coachLoading",
    commitType: "update",
    message: "coach deleted",
    params
  });

const deleteClubCoach = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "deleteClubCoach",
    loadingKey: "coachesLoading",
    storeKey: "coach",
    commitType: "update",
    message: "coach deleted",
    params
  });

const getClubCoach = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "getClubCoach",
    storeKey: "coach",
    loadingKey: "coachLoading",
    commitType: "show",
    params
  });

const getCollegeCoach = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "getCollegeCoach",
    storeKey: "coach",
    loadingKey: "coachLoading",
    commitType: "show",
    silent: "true",
    params
  });

const editClubCoach = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "editClubCoach",
    loadingKey: "coachesLoading",
    storeKey: "coach",
    commitType: "wrappedShow2",
    message: "coach updated",
    params
  });

const uploadImage = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "uploadImage",
    storeKey: "image",
    loadingKey: "imageLoading",
    params
  });

const uploadClubCoachImage = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "uploadClubCoachImage",
    storeKey: "image",
    loadingKey: "image",
    params
  });

const contactCoachByMail = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "contactCoachByMail",
    storeKey: "coachMail",
    loadingKey: "coachMailLoading",
    message: "Email Sent",
    params
  });

const deleteCoachImages = (context, params) =>
  restApiDispatcher(context, {
    resource: Coach,
    action: "deleteCoachImages",
    storeKey: "deleteImages",
    loadingKey: "deleteImagesLoading",
    message: "Image Deleted",
    params
  });

const removeCoachFromList = (context, id) =>
  context.commit("REMOVE_COACH_FROM_LIST", id);

const changeCoachPosition = (context, params) =>
  context.commit("CHANGE_POSITION_FROM_LIST", params);

const changeCoachActivation = (context, params) =>
  context.commit("CHANGE_COACH_ACTIVATION", params);

export default {
  getCoaches,
  getCoach,
  updateCoach,
  toggleActivation,
  updateRole,
  deleteCoach,
  createCoach,
  deleteClubCoach,
  createClubCoach,
  getClubCoach,
  editClubCoach,
  removeCoachFromList,
  changeCoachPosition,
  changeCoachActivation,
  uploadImage,
  uploadClubCoachImage,
  contactCoachByMail,
  deleteCoachImages,
  getCollegeCoach,
  getSingleCoach,
  getSingleCollegeCoach
};
